"use strict";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

Shopify.theme.jsAjaxCart = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsAjaxCart = $.extend(
      this,
      Shopify.theme.getSectionData($section)
    );

    if (isScreenSizeLarge() || this.cart_action == "drawer") {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == "drawer") {
      this.ajaxCartDrawer = $("[data-ajax-cart-drawer]");
      $(document).on("click", "[data-ajax-cart-trigger]", function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.showDrawer();
        dataLayer.push({ event: "optimize.activate-cart" });
        return false;
      });
    } else if (this.cart_action == "mini_cart") {
      this.showMiniCartOnHover();
    }

    $(document).on("click", ".ajax-submit", function (e) {
      e.preventDefault();
      var $addToCartForm = $(this).closest("form");
      dataLayer.push({ event: "optimize.activate-cart" });
      Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
      return false;
    });
    $(document).on("click", "[data-ajax-cart-delete]", function (e) {
      e.preventDefault();
      var lineID = $(this).parents("[data-line-item]").data("line-item");
      var productID = $(this).data("cart-product-id");      
      
      Shopify.theme.jsAjaxCart.removeFromCart(lineID);

      if (Shopify.theme.jsCart) {
        Shopify.theme.jsCart.removeFromCart(lineID);
      }

      addUpsellProduct(productID)      
      eventUpSell()      
      return false;
    });

    document.addEventListener(
      "octane.quiz.addToCart",
      function (e) {
        Shopify.theme.jsAjaxCart.showDrawer();
        Shopify.theme.jsAjaxCart.updateView();
        console.log("completed");
        console.log(e.detail);
      },
      false
    );

    $(document).on("click", "[data-ajax-cart-close]", function (e) {
      e.preventDefault();
      Shopify.theme.jsAjaxCart.hideDrawer();
      Shopify.theme.jsAjaxCart.hideMiniCart();
      return false;
    });
  },
  showMiniCartOnHover: function showMiniCartOnHover() {
    var $el = $("[data-ajax-cart-trigger]");
    $el.hover(
      function () {
        if (
          Shopify.theme_settings.header_layout == "centered" &&
          $(".header-sticky-wrapper").hasClass("is-sticky")
        ) {
          $(".header-sticky-wrapper [data-ajax-cart-trigger]").addClass(
            "show-mini-cart"
          );
        } else {
          $el.addClass("show-mini-cart");
        }
      },
      function () {
        $el.removeClass("show-mini-cart");
      }
    );
  },
  hideMiniCart: function hideMiniCart() {
    if (this.cart_action != "mini_cart") return false;
    var $el = $("[data-ajax-cart-close]").parents("[data-ajax-cart-trigger]");
    $el.removeClass("show-mini-cart");
  },
  toggleMiniCart: function toggleMiniCart() {
    var $el = $(".mobile-header [data-ajax-cart-trigger]"); // Removes url to the cart page so user is not redirected

    $el.attr("href", "#");
    $el.off("click").on("click", function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest("[data-ajax-cart-mini_cart]")) {
        return;
      } // Loads content into ajaxCart container for mobile header

      Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile(); // If user clicks outside the element, toggle the mini cart

      $el.toggleClass("show-mini-cart"); // Calculate height of mini cart

      var announcementHeight = 0;
      var mobileHeaderHeight = parseInt($(".mobile-header").height());

      if (
        typeof Shopify.theme.jsAnnouncementBar !== "undefined" &&
        Shopify.theme.jsAnnouncementBar.enable_sticky
      ) {
        announcementHeight =
          Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
      }

      $(".mobile-header .theme-ajax-cart").css({
        height: "calc(100vh - ".concat(
          mobileHeaderHeight + announcementHeight,
          "px)"
        ),
      });
    });
  },
  showDrawer: function showDrawer() {
    if (this.cart_action != "drawer") return false;
    this.ajaxCartDrawer.addClass("is-visible");
    $(".ajax-cart__overlay").addClass("is-visible");
  },
  hideDrawer: function hideDrawer() {
    if (this.cart_action != "drawer") return false;
    this.ajaxCartDrawer.removeClass("is-visible");
    $(".ajax-cart__overlay").removeClass("is-visible");
  },
  removeFromCart: function removeFromCart(lineID, callback) {
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=0&line=" + lineID,
      dataType: "json",
      success: function success(cart) {
        Shopify.theme.jsAjaxCart.updateView("data");
      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval("(" + XMLHttpRequest.responseText + ")");
        response = response.description;
      },
    });
  },
  removeMultiple: function removeMultiple(updates) {
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: updates,
      dataType: "json",
      success: function success(cart) {
        Shopify.theme.jsAjaxCart.updateView();
      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval("(" + XMLHttpRequest.responseText + ")");
        response = response.description;
      },
    });
  },
  initializeAjaxCart: function initializeAjaxCart() {
    Shopify.theme.asyncView
      .load(
        "/cart", // template name
        "ajax" // view name (suffix)
      )
      .done(function (_ref) {
        var html = _ref.html,
          options = _ref.options;
        $("[data-ajax-cart-content]").html(html.content);

        // initialize progress bar
        Shopify.theme.jsAjaxCart.updateProgress();
        Shopify.theme.jsAjaxCart.updateView();

        // Converting the currencies
        if (Currency.show_multiple_currencies) {
          Shopify.theme.currencyConverter.convertCurrencies();
        }
      })
      .fail(function () {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile: function initializeAjaxCartOnMobile() {
    this.toggleMiniCart();
    Shopify.theme.asyncView
      .load(
        "/cart", // template name
        "ajax" // view name (suffix)
      )
      .done(function (_ref2) {
        var html = _ref2.html,
          options = _ref2.options;
        $(".mobile-header [data-ajax-cart-content]").html(html.content);

        // initialize progress bar
        Shopify.theme.jsAjaxCart.updateProgress();
        Shopify.theme.jsAjaxCart.updateView();
      })
      .fail(function () {
        // some error handling
      });
  },
  addToCart: function addToCart($addToCartForm) {
    var $addToCartBtn = $addToCartForm.find(".button--add-to-cart");
    $.ajax({
      url: "/cart/add.js",
      dataType: "json",
      cache: false,
      type: "post",
      data: $addToCartForm.serialize(),
      beforeSend: function beforeSend() {
        $addToCartBtn.attr("disabled", "disabled").addClass("disabled");
        $addToCartBtn
          .find("span")
          .removeClass("fadeInDown")
          .addClass("animated zoomOut");
        // $addToCartBtn.find('div').removeClass("fadeInDown");
      },
      success: function success(product) {
        var $el = $("[data-ajax-cart-trigger]");
        $addToCartBtn.find(".checkmark").addClass("checkmark-active");

        function addedToCart() {
          if (!isScreenSizeLarge()) {
            $el = $(".mobile-header [data-ajax-cart-trigger]");
            Shopify.theme.scrollToTop($el);
          } else {
            $el = $("[data-ajax-cart-trigger]");
          }

          $el.addClass("show-mini-cart");
          $addToCartBtn.find("span").removeClass("fadeInDown");
        }

        window.setTimeout(function () {
          $addToCartBtn.removeAttr("disabled").removeClass("disabled");
          $addToCartBtn.find(".checkmark").removeClass("checkmark-active");
          $addToCartBtn
            .find(".text, .icon")
            .removeClass("zoomOut")
            .addClass("fadeInDown");
          // $addToCartBtn.find('.money').removeClass('zoomOut')
          // $addToCartBtn.find('div').removeClass('zoomOut').addClass('fadeInDown');
          $addToCartBtn.on(
            "webkitAnimationEnd oanimationend msAnimationEnd animationend",
            addedToCart
          );
        }, 1000);
        if (product.properties) {
          if (product.properties._gift) {
          } else {
            Shopify.theme.jsAjaxCart.showRecommendations(product);
          }
        } else {
          Shopify.theme.jsAjaxCart.showRecommendations(product);
        }

        Shopify.theme.jsAjaxCart.showDrawer();
        Shopify.theme.jsAjaxCart.updateView();

        gtag('event', 'add_to_cart', {
          "value": product.price,
          "items": [
            {
              "id": product.id
            }
          ]
        });

        if (Shopify.theme.jsCart) {
          var _$$ajax;

          $.ajax(
            ((_$$ajax = {
              dataType: "json",
              async: false,
              cache: false,
            }),
            _defineProperty(_$$ajax, "dataType", "html"),
            _defineProperty(_$$ajax, "url", "/cart"),
            _defineProperty(_$$ajax, "success", function success(html) {
              var cartForm = $(html).find(".cart__form");
              $(".cart__form").replaceWith(cartForm);
            }),
            _$$ajax)
          );
        }
      },
      error: function error(XMLHttpRequest) {
        var response = eval("(" + XMLHttpRequest.responseText + ")");
        response = response.description;
        var cartWarning =
          '<p class="cart-warning__message animated bounceIn">'.concat(
            response.replace("All 1 ", "All "),
            "</p>"
          );
        $(".warning").remove();
        $addToCartForm.find(".cart-warning").html(cartWarning);
        $addToCartBtn.removeAttr("disabled").removeClass("disabled");
        $addToCartBtn.find(".icon").removeClass("zoomOut").addClass("zoomIn");
        $addToCartBtn
          .find(".text")
          .text(Shopify.translation.addToCart)
          .removeClass("zoomOut")
          .addClass("zoomIn");
      },
    });
  },
  updateView: function updateView(data) {
    Shopify.theme.asyncView
      .load(
        "/cart", // template name
        "ajax" // view name (suffix)
      )
      .done(function (_ref3) {
        var html = _ref3.html,
          options = _ref3.options;
        const items = options.items;

        let increment = 0;
        let basePrice = 0;

        items.forEach((item) => {
          basePrice += item.final_price * item.quantity;

          if (item.properties["_promo"] === "true") {
            increment++;
          }
        });

        let thersold;

        const bundles = window.onlyCurlsScripts.bundle;

        bundles.forEach((bundle) => {
          if (bundle.name == "sachet") {
            thersold = Number(bundle.price);
          }
        });

        const displayUpsells = () => {
          document.querySelector(`.progress-bar__sachet`).style.display =
            "flex";
          document.querySelector(`.progress-bar__ajax`).style.display = "block";
          document.querySelector(`.sachet-title`).style.display = "block";

          localStorage.setItem("upsell", "false");
        };

        if (increment > 0) {
          document.querySelector(`.progress-bar__sachet`).style.display =
            "none";
          document.querySelector(`.progress-bar__ajax`).style.display = "none";
          document.querySelector(`.sachet-title`).style.display = "none";

          localStorage.setItem("upsell", "true");
        } else if (increment == 0) {
          if (thersold && basePrice >= thersold) {
            displayUpsells();
          }
        }

        const buildBundleItems = (items) => {
          let bundles = buildBundleObjects(items);

          Object.keys(bundles).forEach((bundle) => {});
        };

        const buildBundleObjects = (items) => {
          const bundleObjects = {};

          items.forEach((item) => {
            if (
              item.properties._bundle_type === "4PACK" ||
              item.properties._bundle_type === "2PACK"
            ) {
              let id = item.properties._bundle_id;
              if (bundleObjects[id]) {
                bundleObjects[id].push(item);
              } else {
                bundleObjects[id] = [item];
              }
            }
          });
          return bundleObjects;
        };

        if (options.item_count > 0) {
          var itemList = $(html.content).find(".ajax-cart__list");
          var cartDetails = $(html.content).find(".ajax-cart__details-wrapper");
          $(".ajax-cart__list").replaceWith(itemList);
          $(".ajax-cart__details-wrapper").replaceWith(cartDetails);
          $(".ajax-cart__empty-cart-message").addClass("is-hidden");
          $(".ajax-cart__form").removeClass("is-hidden");
          $("[data-ajax-cart-trigger]").addClass("has-cart-count");
          $('[data-bind="itemCount"]').text(options.item_count);
          // buildBundleItems(items);
          Shopify.theme.jsAjaxCart.updateProgress();
        } else {
          $(".ajax-cart__empty-cart-message").removeClass("is-hidden");
          $(".ajax-cart__form").addClass("is-hidden");
          $("[data-ajax-cart-trigger]").removeClass("has-cart-count");
          $('[data-bind="itemCount"]').text("0");
        }

        const removeBundleOfProducts = (e) => {
          e.preventDefault();
          console.log(e);
          let bundleImages =
            e.target.parentElement.parentElement.querySelectorAll("img");
          let bundleData =
            e.target.parentElement.parentElement.querySelector("#bundle-data");
          let data = { updates: {} };

          bundleData.dataset.bundleKeys.split(",").forEach((key) => {
            console.log(key);
            if (key === "") {
              return;
            }
            if (data.updates[key]) {
              data.updates[key] = 0;
            } else {
              data.updates[key] = 0;
            }
            console.log(data.updates);
          });

          // bundleImages.forEach(img => {
          //   if (data.updates[`${img.dataset.bundleKey}`]) {
          //     data.updates[`${img.dataset.bundleKey}`] = 0;
          //   } else {
          //     data.updates[`${img.dataset.bundleKey}`] = 0;
          //   }
          // })

          Shopify.theme.jsAjaxCart.removeMultiple(data);
        };

        document.querySelectorAll(".cart_bundle button").forEach((item) => {
          item.addEventListener("click", removeBundleOfProducts);
        });

        if (Currency.show_multiple_currencies) {
          Shopify.theme.currencyConverter.convertCurrencies();
        }
      })
      .fail(function () {
        // some error handling
      });
  },
  showRecommendations: function showRecommendations(product) {
    if (window.showRecs === true) {
      let uiRecommendationsModal = document.querySelector(
        "#recommendations-popup"
      );
      let uiRecommendationsOverlay = document.querySelector(
        "#recommendations-overlay"
      );
      let uiAddedProductImg = document.querySelector("#rec-product-added_img");
      let uiAddedProductTitle = document.querySelector(
        "#rec-product-added_title"
      );

      if (product.properties) {
        if (product.properties._recommended) {
        } else {
          uiAddedProductImg.src = product.image;
          uiAddedProductTitle.innerText = product.product_title;
          uiRecommendationsModal.style.display = "block";
          uiRecommendationsOverlay.style.display = "block";
        }
      } else {
        uiAddedProductImg.src = product.image;
        uiAddedProductTitle.innerText = product.product_title;
        uiRecommendationsModal.style.display = "block";
        uiRecommendationsOverlay.style.display = "block";
      }
    }
  },
  updateProgress: function updateProgress() {
    $.ajax({
      url: "/cart.json",
      dataType: "json",
      cache: false,
      type: "get",
      success: function success(data) {
        const variables = {
          container: "progress-bar__container",
          steps: "progress-bar__steps",
          description: "progress-bar__description",
          sachet: "sachet",
          sachetActive: "sachet-active",
          progressSachet: "progress-bar__sachet",
          ajaxSachet: "progress-bar__ajax",
          titleSachet: "sachet-title",
        };

        const enableAjax = (formData) => {
          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          })
            .then((response) => {
              return response.json();
            })
            .then((response) => {
              Shopify.theme.jsAjaxCart.updateView();
              localStorage.setItem("upsell", "true");
              //document.cookie = 'discount_code=P5SMT3';
              sachetDisable();
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        };

        const sachetEnable = () => {
          document.querySelector(`.${variables.progressSachet}`).style.display =
            "flex";
          document.querySelector(`.${variables.ajaxSachet}`).style.display =
            "block";
          document.querySelector(`.${variables.titleSachet}`).style.display =
            "block";

          let sachets = document.querySelectorAll(`.${variables.sachet}`);

          Array.from(sachets).forEach((sach) => {
            sach.addEventListener("click", () => {
              Array.from(sachets).forEach((sachet) => {
                sachet.classList.remove(variables.sachetActive);
              });

              document.querySelector(`.progress-bar__ajax`).innerHTML =
                "Add Your Free Pin Badge";

              sach.classList.add(variables.sachetActive);

              let upsellFormData;

              const addSachetToCart = () => {
                Array.from(sachets).forEach((sachet) => {
                  if (sachet.classList.contains(variables.sachetActive)) {
                    upsellFormData = {
                      items: [
                        {
                          id: sachet.dataset.id,
                          quantity: 1,
                          properties: {
                            _promo: "true",
                          },
                        },
                      ],
                    };
                  }
                });

                enableAjax(upsellFormData);
              };

              if (
                !document
                  .querySelector(`.${variables.ajaxSachet}`)
                  .classList.contains("init-done")
              ) {
                document
                  .querySelector(`.${variables.ajaxSachet}`)
                  .addEventListener("click", addSachetToCart);
                document
                  .querySelector(`.${variables.ajaxSachet}`)
                  .classList.add("init-done");
              }
            });
          });
        };

        const sachetDisable = () => {
          document.querySelector(`.${variables.progressSachet}`).style.display =
            "none";
          document.querySelector(`.${variables.ajaxSachet}`).style.display =
            "none";
          document.querySelector(`.${variables.titleSachet}`).style.display =
            "none";
        };

        const createBundle = (bundle) => {
          const bundlePrice = Number(bundle.price);
          let element;

          // hide or show sachet
          const localUpsell = localStorage.getItem("upsell");

          // if local upsell is present, disable sachet
          if (localUpsell == "true") {
            sachetDisable();
          } else {
            // if local upsell isn't present, check if bundle == sachet and then:
            // check if original_total > bundle price
            // if it is, enable sachets
            if (bundle.name.trim() == "sachet") {
              if (data.items_subtotal_price >= bundlePrice) {
                sachetEnable();
              } else {
                sachetDisable();
              }
            }
          }

          if (data.items_subtotal_price >= bundlePrice) {
            element = `
            <div class="element active" >
            ${bundle.image}
                <span  > ${bundle.active}  </span> 
            </div>`;
          } else {
            let priceDifference =
              (bundlePrice - data.items_subtotal_price) / 100;
            let amount = `£${priceDifference}`;
            element = `
            <div class="element" >
            ${bundle.image}
                <span> ${bundle.default.replace("{{ price }}", amount)}</span>
            </div>`;
          }

          return element;
        };

        const init = (_) => {
          let descriptions = document.querySelector(
            ".progress-bar__description"
          );
          let description = document.querySelector(`.${variables.description}`);

          const bundles = window.onlyCurlsScripts.bundle;

          const heading = `<span class="title" > ${window.onlyCurlsScripts.progressDefault} </span>`;

          description.innerHTML = heading;

          bundles.forEach((bundle) => {
            const createdBundle = createBundle(bundle);
            let htmlContent = descriptions.innerHTML;
            description.innerHTML = htmlContent + createdBundle;
          });

          let actives = document.querySelectorAll(".element.active");

          if (actives.length > 0) {
            Array.from(actives).forEach((active) => {
              let offSet = active.offsetTop - active.parentElement.offsetTop;

              document.querySelector(
                ".progress-bar__steps-inner"
              ).style.height = `${offSet + 16}px`;
            });
          } else {
            document.querySelector(
              ".progress-bar__steps-inner"
            ).style.height = `20px`;
          }
        };

        init();
      },
    });
  },
  unload: function unload($section) {
    // Clear event listeners in theme editor
    $(".ajax-submit").off();
    $("[data-ajax-cart-delete]").off();
  },
};
